import { action, computed, observable } from "mobx";
import NestStore from "~/stores/NestStore";
import CreditAccountRepository from "~/repository/Credit/CreditAccountRepository";
import CreditAccount from "~/models/Credit/CreditAccount";

class CreditAccountStore extends NestStore {
  /**
   * @property {Array}
   */
  @observable creditAccounts = [];

  creditAccountRepository = null;

  constructor() {
    super();

    this.creditAccountRepository = new CreditAccountRepository();

    this.setDefaultSearchParams();
  }

  @action
  loadIndex() {
    this.isLoading = true;

    return Promise.all([this.getAll()]).finally(() => {
      this.isLoading = false;
    });
  }

  /**
   * Get all.
   */
  @action
  getAll() {
    const params = {
      offset: this.offset,
      limit: this.pagination.itemsPerPage,
    };

    if (this.searchParams.description !== "") {
      params.description = this.searchParams.description;
    }

    if (this.searchParams.onlyShowPurchases) {
      params.onlyShowPurchases = 1;
    }

    return this.creditAccountRepository.fetch(params).then(response => {
      this.processEntities(response.data.creditAccounts);
      this.processPagination(response.data.pagination);
    });
  }

  @action
  processEntities(creditAccounts = []) {
    this.creditAccounts = [];

    creditAccounts.forEach(creditAccountArray => {
      const creditAccount = new CreditAccount(creditAccountArray);

      this.creditAccounts.push(creditAccount);
    });
  }

  /**
   * Change the pagination page and load index.
   */
  @action
  changePage(page) {
    this.pagination.currentPage = page;

    return this.loadIndex();
  }

  /**
   * Set default search params.
   */
  @action
  setDefaultSearchParams() {
    this.searchParams.description = "";
    this.searchParams.onlyShowPurchases = false;
  }

  @computed
  get hasSelectedFilters() {
    return this.searchParams.description !== "" || this.searchParams.onlyShowPurchases !== false;
  }
}

export default CreditAccountStore;
